import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import Box from '@material-ui/core/Box'
import { AlertCircleIcon } from '~/assets/icons'
import { FieldError } from 'react-hook-form'

export type StatusTooltipProps = {
  title: string | FieldError,
  className?: string,
  iconColor?: string
}

export const StatusTooltip: React.FC<StatusTooltipProps> = ({ title, className, iconColor }) => {
  return (
    <Tooltip title={title} placement='top'>
      <Box>
        <AlertCircleIcon cursor='default' className={className} htmlColor={iconColor && iconColor} />
      </Box>
    </Tooltip>
  )
}
